import React, { useState } from "react";
import { Box, Modal } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";

function getModalStyle() {
  return {
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
  };
}

const AppModal = (props) => {
  const { modalBody, modalTitle, modalButtons, clsNm } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  return (
    <Modal open={true}>
      <div style={modalStyle} className={`modal-cont ${classes.paper} ${clsNm}`}>
        {modalTitle && <Box component="div">{modalTitle}</Box>}
        {modalBody}
        {modalButtons && <Box component="div">{modalButtons}</Box>}
      </div>
    </Modal>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: "45%",
      // R-3 / P7. DEFENCE IN DEPTH, not a live fix. A hard 500px minimum on this
      // centre-translated box overflows both edges below 500px — but the app does
      // not currently overflow, because `create-quiz-page.scss` already bounds
      // every `.modal-cont` app-wide at <= 600px via a top-level `!important`
      // inside a media block, and `native-polish.scss` adds another under
      // `body.native-app`. The bound belongs on the shared component rather than
      // on a global misplaced in a page stylesheet, which a later cleanup would
      // correctly re-scope and silently re-open the overflow.
      //
      // Changes nothing today: measured identical in the shipped cascade at every
      // viewport (rr-ba4564b48c43). Change band 300..539px; byte-identical from
      // 540 up, where calc(100vw - 40px) reaches 500.
      //
      // Two components import this modal — exam-header.jsx:14, exam-footer.jsx:4 —
      // across four renders. Guarded by scripts/modal-viewport-fit-probe.js, which
      // reads this declaration out of this file; see its header for the isolation
      // rationale and the thresholds.
      minWidth: "min(500px, calc(100vw - 40px))",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #fff",
      boxShadow: theme.shadows[5],
    },
  })
);

export default AppModal;
